import { Api } from './Api'

class SwishPayment {
  post (customerId, ocr, cellPhone, signal) {
    const body = {
      customer_id: customerId,
      ocr,
      cell_phone_number: cellPhone
    }
    return fetch(`${Api.getBaseUrl()}swishpayment`, Api.getOptions('POST', body, signal))
  }
}

export default SwishPayment
